<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <video class="bg-video" autoplay loop muted playsinline>
        <source src="@/assets/1678779171725-jwprOaEf.mp4" type="video/mp4">
      </video>
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <!-- Header 组件 -->
        <PageHeader :showNav="true" activeNavKey="blueprint"/>

        <div class="center">
          <!-- <div class="center-header">
            <div class="nav-tabs">
              <div v-for="(item, index) in navTabs" :key="index"
                :class="['nav-tab-item', { active: activeTab === index }]" @click="handleTabClick(index)">
                {{ item }}
              </div>
            </div>
          </div> -->

          <!-- 主要内容区域：左右布局 -->
          <div class="main-content">
            <!-- 左侧：产改进行时 -->
            <div class="left-section">
              <!-- 整体容器（包含产改和党群） -->
              <div class="reform-party-container">
                <!-- 产改进行时标题 -->
                <div class="section-header">
                  <img src="../assets/page2/1675143770257-pNifja_p.webp"
                       alt="产改进行时" class="header-image">
                  <span class="title-text">产改进行时</span>
                </div>

                <!-- 上半部分：6个数据卡片 -->
                <div class="top-cards">
                  <div v-for="(item, index) in reformData" :key="index" class="reform-card"
                       :style="{ '--card-color': item.color, backgroundImage: 'url(' + item.bg + ')' }">
                    <div class="card-icon-wrapper">
                      <div class="card-icon">
                        <img :src="item.icon" alt=""
                             style="width: 100%; height: 100%; object-fit: contain;">
                      </div>
                    </div>
                    <div class="card-content">
                      <div class="card-label">{{ item.label }}</div>
                      <div class="card-value-wrapper">
                        <span class="card-value">{{ item.value }}</span>
                        <span class="card-unit">{{ item.unit }}</span>
                      </div>
                    </div>
                    <div class="card-bg-pattern"></div>
                  </div>
                </div>

                <!-- 下半部分：党群组织建设 -->
                <div class="bottom-section">
                  <div class="section-title">
                    <div class="title-decoration">
                      <img src="../assets/page2/1678762309227-E6RP8z2R.png"
                           alt="" class="decoration-img">
                      <span class="title-text">党群组织建设</span>
                    </div>

                  </div>
                  <div class="organization-content">
                    <!-- 中央圆形图表 - 党群组织建设同心圆 -->
                    <!-- 周围5个组织数据 -->
                    <div class="organization-cards">
                      <div v-for="(item, index) in organizationData" :key="index" class="org-card"
                           :class="`org-card-${index + 1}`">
                        <div class="org-icon-wrapper">
                          <div class="org-icon-dot"></div>
                        </div>
                        <div class="org-content">
                          <div class="org-label">{{ item.label }}</div>
                          <div class="org-value-wrapper">
                            <span class="org-value">{{ item.value }}</span>
                            <span class="org-unit">{{ item.unit }}</span>
                          </div>
                        </div>
                        <div class="org-card-bg"></div>
                      </div>
                    </div>
                    <div class="center-chart">
                      <div class="party-organization-circle">
                        <!-- 外层光圈 - 党群组织建设1.png -->
                        <div class="outer-ring-img"></div>
                        <!-- 中心图标 - 党群组织建设1.webp -->
                        <div class="center-icon-img"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 整体容器结束 -->
            </div>

            <!-- 右侧：3D地球地图 -->
            <div class="right-section">
              <!-- 三年行动进度条 -->
              <ActionPlanTimeline/>
              <div class="map-container">
                <Globe3DMap :wdgcList="wdgcList"/>
              </div>
            </div>
          </div>
          <!-- Footer 组件 -->
          <div class="footer-container">
            <PageFooter />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from '../utils/drawMixin'
import PageHeader from '../components/page-header/index.vue'
import PageFooter from '../components/page-footer/index.vue'
import Globe3DMap from '../components/globe-3d-map/index.vue'
import ActionPlanTimeline from '../components/action-plan-timeline/index.vue'
import {get} from "@/utils/request";

export default {
  mixins: [drawMixin],
  components: {
    PageHeader,
    PageFooter,
    Globe3DMap,
    ActionPlanTimeline
  },
  data() {
    return {
      VUE_APP_API_BASE_URL:"https://dp.houkongfan.cn",
      loading: true,
      wdgcList: [],  // 五类数据
      activeTab: 1, // 产改蓝图是第二个标签
      navTabs: ['产改总览', '产改蓝图', '产业洞察', '企业观察'],
      // 产改进行时数据（6个卡片）
      reformData: [{
        label: '职工人数',
        value: '22,675',
        unit: '人',
        icon: require('@/assets/page2/1762141139961-OVWVX9Na.png'),
        bg: require('@/assets/page2/1678419206945-Sa0Itmjo.png')
      },
        {
          label: '技能人才',
          value: '6,422',
          unit: '人',
          icon: require('@/assets/page2/1762001574748-LOWk05XE.png'),
          bg: require('@/assets/page2/1678419206180-21r-hY8E.png')
        },
        {
          label: '共产党员',
          value: '4,322',
          unit: '人',
          icon: require('@/assets/page2//1762141205102-X1m0jV0L.png'),
          bg: require('@/assets/page2/1762059588153-az2cPxCy.png')
        },
        {
          label: '高技能人才',
          value: '93',
          unit: '人',
          icon: require('@/assets/page2/1761893217433-ueIOG-jE.png'),
          bg: require('@/assets/page2/1678419208028-foajAi-F.png')
        },
        {
          label: '两代表一委员',
          value: '72',
          unit: '人',
          icon: require('@/assets/page2/1762002831342-ULxnXwuH.png'),
          bg: require('@/assets/page2/1762003921895-ucu5g0he.png')
        },
        {
          label: '发明专利',
          value: '1,850',
          unit: '项',
          icon: require('@/assets/page2/1762152292515-diOWDDsE.png'),
          bg: require('@/assets/page2/1678419208028-foajAi-F.png')
        },
      ],
      // 党群组织建设数据
      organizationData: [{
        label: '党组织',
        value: '513',
        unit: '家'
      }, // 左上角
        {
          label: '工会',
          value: '627',
          unit: '家'
        }, // 右上
        {
          label: '妇联',
          value: '258',
          unit: '家'
        }, // 右下
        {
          label: '团支部',
          value: '330',
          unit: '家'
        }, // 左中
        {
          label: '科协',
          value: '9',
          unit: '家'
        }, // 左下
      ],
    }
  },
  mounted() {
    this.cancelLoading()
    this.setActiveTabByRoute()
    this.loadInfo();
    this.$nextTick(() => {
      setTimeout(() => {
        this.calcRate()
      }, 600)
    })
  },
  watch: {
    '$route'() {
      this.setActiveTabByRoute()
    }
  },
  beforeDestroy() {
  },
  methods: {
    async loadInfo() {
      this.loading = true
      const url =this.VUE_APP_API_BASE_URL + "/dev-api/system/page2/queryList"
      const result = await get(url)
      if (result.success) {
        // 处理产改进行时数据 (zpzlList)
        if (result.data.zpzlList && result.data.zpzlList.length > 0) {
          const zpzlData = result.data.zpzlList[0];

          // 更新 reformData 数组中的值
          this.$set(this.reformData[0], 'value', zpzlData.zgrsNum?.toString() || '0');  // 职工人数
          this.$set(this.reformData[1], 'value', zpzlData.jnrcNum?.toString() || '0');  // 技能人才
          this.$set(this.reformData[2], 'value', zpzlData.gcdyNum?.toString() || '0');  // 共产党员
          this.$set(this.reformData[3], 'value', zpzlData.gjncrNum?.toString() || '0'); // 高技能人才
          this.$set(this.reformData[4], 'value', zpzlData.ldbywyNum?.toString() || '0'); // 两代表一委员
          this.$set(this.reformData[5], 'value', zpzlData.fmzlNum?.toString() || '0');  // 发明专利
        }

        // 处理党群组织建设数据 (dqzzjsList)
        if (result.data.dqzzjsList && result.data.dqzzjsList.length > 0) {
          const dqzzjsData = result.data.dqzzjsList[0];

          // 更新 organizationData 数组中的值
          this.$set(this.organizationData[0], 'value', dqzzjsData.dzzNum?.toString() || '0');  // 党组织
          this.$set(this.organizationData[1], 'value', dqzzjsData.ghNum?.toString() || '0');   // 工会
          this.$set(this.organizationData[2], 'value', dqzzjsData.flNum?.toString() || '0');   // 妇联
          this.$set(this.organizationData[3], 'value', dqzzjsData.tzbNum?.toString() || '0');  // 团支部
          this.$set(this.organizationData[4], 'value', dqzzjsData.kxNum?.toString() || '0');   // 科协
        }
        //处理五大工程的数据
        this.wdgcList = result.data.wdgcList


        this.loading = false
      }
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    // 根据路由设置激活的标签
    setActiveTabByRoute() {
      const routeMap = {
        '/': 0,
        '/blueprint': 1,
        '/insight': 2,
        '/benchmark': 3
      }
      this.activeTab = routeMap[this.$route.path] || 1
    },
    handleTabClick(index) {
      this.activeTab = index
      // 可以根据标签切换路由
      const routes = ['/', '/blueprint', '/insight', '/benchmark']
      if (routes[index] && this.$route.path !== routes[index]) {
        this.$router.push(routes[index])
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/index.scss';

.center-header {
  width: 100%;
  font-size: 30px;
  height: 35px;
  font-family: cursive;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.footer-container {
  position: absolute;
  bottom: -25px;
  left: 0;
  right: 0;
}
.bg-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  opacity: 0.3;
  z-index: 0;
  pointer-events: none;
}
// 主要内容区域
.main-content {
  display: flex;
  gap: 20px;
  padding: 0 20px;
  height: calc(1080px - 70px - 10px - 32px); // 总高度1080 - header 70 - center的margin-top 10 - bg的padding 32
  // 也就是 968px

  // 左侧：产改进行时
  .left-section {
    flex: 3;
    display: flex;
    flex-direction: column;
    gap: 20px;
    min-width: 0;

    // 整体容器（包含产改和党群）
    .reform-party-container {
      background: linear-gradient(135deg, rgba(7, 20, 36, 0.7) 0%, rgba(0, 30, 60, 0.5) 100%);
      border: 1px solid rgba(0, 217, 255, 0.3);
      border-radius: 12px;
      padding: 0 20px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      position: relative;
      display: flex;
      flex-direction: column;
      gap: 20px;
      flex: 1;
      min-height: 0;


    }

    // 产改进行时标题
    .section-header {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 40px;

      .title-text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 18px;
        font-weight: 600;
        color: #fff;
        text-shadow: 0 0 10px rgba(0, 217, 255, 0.5);
        letter-spacing: 1px;
        z-index: 2;
        white-space: nowrap;
      }

      .header-image {
        width: 100%;
        height: auto;
        object-fit: contain;
        position: relative;
        z-index: 1;
      }
    }

    // 上半部分：6个数据卡片
    .top-cards {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 15px;
      flex-shrink: 0;

      .reform-card {
        background-repeat: no-repeat;
        background-size: 100% 100%;
        background-position: center center;
        // background: linear-gradient(135deg, rgba(7, 20, 36, 0.8) 0%, rgba(0, 30, 60, 0.6) 100%);
        // border: 1px solid rgba(0, 217, 255, 0.2);
        // border-left: 4px solid var(--card-color);
        // border-radius: 8px;
        padding: 18px 20px;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        overflow: hidden;

        &::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(0, 217, 255, 0.05) 0%, transparent 100%);
          opacity: 0;
        }

        // &:hover {
        //   background: linear-gradient(135deg, rgba(7, 20, 36, 0.95) 0%, rgba(0, 30, 60, 0.8) 100%);
        //   border-color: var(--card-color);
        //   transform: translateY(-3px);
        //   box-shadow: 0 6px 20px rgba(0, 217, 255, 0.3);

        //   &::before {
        //     opacity: 1;
        //   }

        //   .card-icon-wrapper .icon-glow {
        //     opacity: 0.6;
        //     transform: scale(1.2);
        //   }
        // }

        .card-icon-wrapper {
          position: absolute;
          top: 15px;
          right: 15px;
          width: 50px;
          height: 50px;
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 2;

          .card-icon {
            font-size: 36px;
            position: relative;
            z-index: 2;
            filter: drop-shadow(0 0 8px rgba(0, 217, 255, 0.5));
          }

          .icon-glow {
            position: absolute;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            opacity: 0.3;
            filter: blur(12px);
            transition: all 0.3s;
            z-index: 1;
          }
        }

        .card-content {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          padding-right: 60px;

          .card-label {
            font-size: 16px;
            color: #9ab3c0;
            margin-bottom: 15px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .card-value-wrapper {
            display: flex;
            align-items: baseline;
            gap: 6px;
            flex-wrap: wrap;

            .card-value {
              font-size: 32px;
              font-weight: 700;
              color: var(--card-color);
              line-height: 1.2;
              text-shadow: 0 0 12px rgba(0, 217, 255, 0.4);
              font-family: 'Arial', sans-serif;
            }

            .card-unit {
              font-size: 14px;
              color: #6b7d8f;
              font-weight: 500;
            }
          }
        }

        .card-bg-pattern {
          position: absolute;
          right: -20px;
          bottom: -20px;
          width: 100px;
          height: 100px;
          background: radial-gradient(circle, rgba(0, 217, 255, 0.1) 0%, transparent 70%);
          border-radius: 50%;
          pointer-events: none;
        }
      }
    }

    // 下半部分：党群组织建设
    .bottom-section {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;

      .section-title {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        font-size: 20px;
        font-weight: 600;
        color: #fff;
        flex-shrink: 0;
        position: relative;
        width: 100%;
        padding: 0;

        .title-decoration {
          position: relative;
          width: 100%;
          height: auto;
          display: flex;
          align-items: center;
          justify-content: center;

          .title-text {
            position: absolute;
            left: 20%;
            top: 50%;
            transform: translate(-50%, -50%);
            font-size: 20px;
            font-weight: 600;
            color: #fff;
            text-shadow: 0 0 10px rgba(0, 217, 255, 0.5);
            letter-spacing: 1px;
            z-index: 2;
            white-space: nowrap;
          }

          .decoration-img {
            width: 100%;
            height: auto;
            object-fit: contain;
            filter: drop-shadow(0 0 5px rgba(0, 217, 255, 0.6));
          }
        }
      }

      .organization-content {
        flex: 1;
        position: relative;
        width: 100%;
        min-height: 0;

        // 中央圆形图表 - 党群组织建设同心圆
        .center-chart {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 320px;
          height: 320px;
          z-index: 1;

          .party-organization-circle {
            width: 100%;
            height: 100%;
            position: relative;

            // 外层光圈 - 党群组织建设1.png
            .outer-ring-img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 100%;
              height: 100%;
              background-image: url('../assets/blueprint/党群组织建设1.png');
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              opacity: 0.8;
              animation: rotate 20s linear infinite;
            }

            // 中心图标 - 党群组织建设1.webp
            .center-icon-img {
              position: absolute;
              top: 50%;
              left: 50%;
              transform: translate(-50%, -50%);
              width: 40%;
              height: 40%;
              background-image: url('../assets/blueprint/党群组织建设1.webp');
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
              opacity: 0.9;
              animation: pulse 3s ease-in-out infinite;
            }
          }
        }

        // 周围组织数据卡片
        .organization-cards {
          position: relative;
          width: 100%;
          height: 100%;
          z-index: 2;

          .org-card {
            position: absolute;
            background: linear-gradient(135deg, rgba(0, 217, 255, 0.15) 0%, rgba(0, 217, 255, 0.05) 100%);
            border: 1px solid rgba(0, 217, 255, 0.3);
            border-radius: 8px;
            padding: 14px 18px;
            min-width: 110px;
            transition: all 0.3s ease;
            overflow: hidden;

            &::before {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              background: linear-gradient(135deg, rgba(0, 217, 255, 0.1) 0%, transparent 100%);
              opacity: 0;
              transition: opacity 0.3s;
            }

            &:hover {
              background: linear-gradient(135deg, rgba(0, 217, 255, 0.25) 0%, rgba(0, 217, 255, 0.1) 100%);
              border-color: rgba(0, 217, 255, 0.6);
              transform: translateY(-2px) scale(1.05);
              box-shadow: 0 4px 15px rgba(0, 217, 255, 0.3);

              &::before {
                opacity: 1;
              }

              .org-icon-wrapper .org-icon-dot {
                transform: scale(1.3);
                box-shadow: 0 0 15px rgba(0, 217, 255, 0.8);
              }
            }

            .org-icon-wrapper {
              position: absolute;
              top: 8px;
              right: 8px;
              width: 8px;
              height: 8px;

              .org-icon-dot {
                width: 100%;
                height: 100%;
                background: #00d9ff;
                border-radius: 50%;
                box-shadow: 0 0 6px rgba(0, 217, 255, 0.6);
                transition: all 0.3s;
              }
            }

            .org-content {
              text-align: center;

              .org-label {
                font-size: 18px;
                color: #9ab3c0;
                margin-bottom: 8px;
                font-weight: 500;
              }

              .org-value-wrapper {
                display: flex;
                align-items: baseline;
                justify-content: center;
                gap: 4px;

                .org-value {
                  font-size: 26px;
                  font-weight: 700;
                  color: #fff;
                  line-height: 1.2;
                  text-shadow: 0 0 10px rgba(0, 217, 255, 0.4);
                  font-family: 'Arial', sans-serif;
                }

                .org-unit {
                  font-size: 16px;
                  color: #6b7d8f;
                  font-weight: 500;
                }
              }
            }

            .org-card-bg {
              position: absolute;
              bottom: 0;
              left: 0;
              right: 0;
              height: 2px;
              background: linear-gradient(90deg, transparent 0%, rgba(0, 217, 255, 0.5) 50%, transparent 100%);
              opacity: 0.5;
            }

            // 定位5个卡片（围绕中心圆形图表）
            &.org-card-1 {
              // 左上角
              top: 10%;
              left: 20%;
            }

            &.org-card-2 {
              // 右上
              top: 20%;
              right: 5%;
            }

            &.org-card-3 {
              // 右下
              bottom: 20%;
              right: 2%;
            }

            &.org-card-4 {
              // 左中
              top: 50%;
              left: 5%;
              transform: translateY(-50%);
            }

            &.org-card-5 {
              // 左下
              bottom: 10%;
              left: 20%;
            }
          }
        }
      }
    }
  }

  // 右侧：3D地球地图
  .right-section {
    flex: 7;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 15px;

    .map-container {
      flex: 1;
      min-height: 0;
      width: 100%;
      background: rgba(7, 20, 36, 0.4);
      border: 1px solid rgba(0, 217, 255, 0.2);
      border-radius: 8px;
      padding: 20px;
      overflow: hidden;
    }
  }
}

@keyframes dotPulse {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.7;
    transform: scale(1.1);
  }
}

@keyframes centerGlow {

  0%,
  100% {
    opacity: 0.8;
    transform: translate(-50%, -50%) scale(1);
  }

  50% {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1.1);
  }
}

@keyframes ringRotate {
  0% {
    transform: translate(-50%, -50%) rotate(0deg);
  }

  100% {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

@keyframes lineGlow {

  0%,
  100% {
    opacity: 0.4;
  }

  50% {
    opacity: 0.8;
  }
}

@keyframes markerBlink {

  0%,
  100% {
    opacity: 1;
    transform: scale(1);
  }

  50% {
    opacity: 0.5;
    transform: scale(0.8);
  }
}

@keyframes nodePulse {

  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
  }

  50% {
    transform: translate(-50%, -50%) scale(1.1);
    opacity: 0.8;
  }
}

@keyframes nodeRing {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.6;
  }

  100% {
    transform: translate(-50%, -50%) scale(1.5);
    opacity: 0;
  }
}

@keyframes markerPulse {
  0% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.8;
  }

  100% {
    transform: translate(-50%, -50%) scale(3);
    opacity: 0;
  }
}
</style>

// 旋转动画 - 外层光圈
@keyframes rotate {
from {
transform: translate(-50%, -50%) rotate(0deg);
}
to {
transform: translate(-50%, -50%) rotate(360deg);
}
}

// 脉冲动画 - 中心图标
@keyframes pulse {
0%, 100% {
transform: translate(-50%, -50%) scale(1);
opacity: 0.9;
}
50% {
transform: translate(-50%, -50%) scale(1.05);
opacity: 1;
}
}
